export default __webpack_public_path__ + "static/media/contactIcon.bf2144ae.svg";